import React, { Component } from 'react';
import Swal from 'sweetalert2';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true });

        // Log the error to the console (or to a logging service)
        console.error(error, errorInfo);

        // Display a SweetAlert modal for the user
        Swal.fire({
            title: 'Oops!',
            text: 'Something went wrong. Please try again later.',
            icon: 'error',
            confirmButtonText: 'OK',
        });
    }

    render() {
        return this.state.hasError ? null : this.props.children;
    }
}

export default ErrorBoundary;
